import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="form"
export default class extends Controller {
  static targets = ['focus'];

  focus() {
    if (this.hasFocusTarget) {
      this.focusTarget.focus();
    }
  }

  focusTargetConnected(target) {
    target.focus();
  }

  // Define a "trim" parameter with value "true" (using [data-form-trim-param="true"]) to trim the value of the field
  // that caused the event beforehand.
  submit({ params, target }) {
    if (params.trim) {
      target.value = target.value.trim();
    }
    this.element.requestSubmit();
  }
};
